export const ALL_ACCOUNT_PAGE_REQUEST = "ALL_ACCOUNT_PAGE_REQUEST"
export const ALL_ACCOUNT_PAGE_SUCCESS = "ALL_ACCOUNT_PAGE_SUCCESS"
export const ALL_ACCOUNT_PAGE_FALUIRE = "ALL_ACCOUNT_PAGE_FALUIRE"

export const PATCH_ACCOUNTS_REQUEST = "PATCH_ACCOUNTS_REQUEST"
export const PATCH_ACCOUNTS_SUCCESS = "PATCH_ACCOUNTS_SUCCESS"
export const PATCH_ACCOUNTS_FALUIRE = "PATCH_ACCOUNTS_FALUIRE"
